import { IConvertedSession, IServerResponseSession } from 'shared/models/Upgaming'

export class UpgamingConverter {
  convertSessionUrl = (data: IServerResponseSession): IConvertedSession => {
    const { token, url } = data

    return {
      url,
      token,
    }
  }
}
